module.exports = __webpack_public_path__ + "static/media/profile.cbc3dc22.jpg";